import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Attribution } from '../../models/Attribution';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { Step4 } from '../../../../../shared/models/component-messages/diveAT/step4';
import { TypeAttributionMarcheLot } from '../../models/TypeAttributionMarcheLot';
import { CTRL_268 } from '../../../../validators/268/ctrl268';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Component({
	selector: 'app-step4',
	templateUrl: './step4.component.html'
})
export class Step4Component implements OnInit {

	private LOG: LogService = new LogService(Step4Component);

	@Input() attribue: TypeAttributionMarcheLot;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;
	public current_uid = '';

	public step4 = new Step4();
	public rg1 = CTRL_268.id + '_2';

	constructor(private formExtractorService: FormExtractorService,
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private avisDataTransferService: AvisDataTransferService
	) { }

	ngOnInit(): void {
	}

	getUid() {
		return this.uid + '_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution';
	}

	public getType() {
		return this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.attribution.resultatAttribution;
	  }
	  public isAttribue(): boolean {
		return this.getType() !== RadioCheckBoxEnum.sansSuite
		  && this.getType() !== RadioCheckBoxEnum.infructueux;
		}

	  public isAttributionUnique(): boolean {
		if (this.getType() === RadioCheckBoxEnum.attribueUnique) {
			this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_268Names_json() }));
		}
		return this.getType() === RadioCheckBoxEnum.attribueUnique;
	  }

	  getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	  }

	  private getCtrl_268Names_json(): any {
		const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
		const cp = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeAdresseCompleteMorale_SepSep_TypeAdresse_SepAtt_cp';
		return { firstChamp: deptPub, secondChamp: cp };
	  }

}
